export default __webpack_public_path__ + "static/media/home-bg.44cf5eca.png";